<script setup lang="ts">
defineProps({
  loadingItemsCount: {
    type: Number,
    required: false,
    default: 6
  },
  loadingItemsHasArrow: {
    type: Boolean,
    required: false,
    default: false
  }
});
</script>

<template>
  <div class="w-full flex flex-col gap-1">
    <div
      v-for="index in new Array(loadingItemsCount).fill(0)"
      :key="index"
      class="w-full px-6 py-2 flex flex-row gap-2 animate-pulse items-center"
    >
      <div
        v-if="loadingItemsHasArrow"
        class="ml-2 w-0 h-0 border-t-[7px] border-t-transparent border-b-[7px] border-b-transparent border-l-[11px] border-l-gray-300 my-2"
      />
      <div class="w-5 h-5 rounded bg-gray-300" />
      <div class="bg-gray-300 animate-pulse py-2 h-5 w-32 rounded" />
    </div>
  </div>
</template>
